var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.airlineKnown)?_c('div',{staticClass:"flightlogo",style:({ backgroundImage: _vm.airlineLogo })}):_c('b',[_vm._v(" "+_vm._s(_vm.flightNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }